import { createSlice } from "@reduxjs/toolkit";
import { ISubStepslice } from "../../../models/freshman/subStep";

const initialSubStepState : ISubStepslice = {
    subStep : undefined,
    subSteps : undefined,
    keyValuePair : undefined,
}

const subStepSlice = createSlice({
    name: "subStep",
    initialState: initialSubStepState,
    reducers: { 
      setSubStep: (state, action: { payload: any }) => {
        state.subStep = action.payload;
      },
      setSubSteps: (state, action: { payload: any }) => {
        state.subSteps = action.payload;
      },
      setKeyValuePair: (state, action: { payload: any }) => {
        state.keyValuePair = action.payload;
      }
    },
  });

  export const { setSubStep, setSubSteps, setKeyValuePair } =
  subStepSlice.actions;
  
  const subStepReducer = subStepSlice.reducer;
  
  export type subStepState = ReturnType<typeof subStepReducer>;
  
  export default subStepReducer;